import idConfig from 'utils/ecommerce/services/id.config';
import { env as E } from 'config/app.config';

export const getIdentity = () => {
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	return {
		method: 'POST',
		url: `/wcs/resources/store/${storeId}/omantelidentity`,
	};
};
